/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link, Redirect } from 'react-router-dom';
import MainHeader from '../header';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import MainFooter from '../../components/Core/footer';

import axios from 'axios';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: "", password: "", mealtristToken: "", confirmationPhone: this.props.confirmationPhone, redirecting: "", provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleEmail = this.handleEmail.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.login = this.login.bind(this);
    }

    handleEmail(e) {
        this.setState({email: e.target.value});
    }

    handlePassword(e) {
        this.setState({password: e.target.value});
    }

    login(e) {
        const globalThis = this;
        const customer = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber
        };

        axios.post(process.env.REACT_APP_API_HOST + '/' + 'api/auth/login', {
            email: this.state.email,
            password: this.state.password
        })
            .then(function (response) {
                debugger;
                const dataResponse = response.data;
                if(typeof(dataResponse) === "object") {
                    if(typeof(dataResponse.message) !== "undefined") {
                        if(dataResponse.message.indexOf("token_generated") > -1) {
                            if(typeof(dataResponse.data) !== "undefined") {
                                localStorage.clear();
                                debugger;
                                let token = dataResponse.data.token;
                                localStorage.setItem("mealToken", token);

                                globalThis.setState(prevState => ({
                                    redirecting: <Redirect to="/feed"/>
                                }));
                            }
                        }
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    componentDidMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }
        const customer =  {
            token: ""
        }
        let mealToken = localStorage.getItem("mealToken");
        console.log(mealToken);
        if(mealToken !== "") {
            customer.token = mealToken;
        }

    }

    //TODO set referrer url link in containers first child link
    render() {

        let output =
            <div>
                <MainHeader/>
                <div className="container-fluid main-body-content">
                <div className="panel panel-default">
                    <div className="panel-heading text-center"><h3>Login and plan away!</h3></div>

                    <div className="panel-body">
                        <ReactBootstrap.Form horizontal>
                            <div className="info1-widget">
                                <div className="info-top clearfix">
                                    {/*<!--<h3 className="pull-left"><span>3</span> Enter Customer's Information</h3>-->*/}
                                    <h3 className="text-center margin-bottom-2-half">Login Below. If you do not have a login yet please sign up <Link to="/register">Here!</Link></h3>
                                </div>
                                <div className="inner clearfix">
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                        <div className="row">
                                        <ReactBootstrap.Col lg={3}>
                                        </ReactBootstrap.Col>
                                        <ReactBootstrap.Col lg={6}>
                                            <ReactBootstrap.FormControl type="email" onChange={this.handleEmail} placeholder="Email" />
                                        </ReactBootstrap.Col>
                                        </div>
                                    </ReactBootstrap.FormGroup>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formGroupPassword">
                                        <div className="row">
                                        <ReactBootstrap.Col lg={3}>
                                        </ReactBootstrap.Col>
                                        <ReactBootstrap.Col lg={6}>
                                            <ReactBootstrap.FormControl type="password" onChange={this.handlePassword} placeholder="Password" />
                                        </ReactBootstrap.Col>
                                        </div>
                                    </ReactBootstrap.FormGroup>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formGroupLogin">
                                        <div className="row">
                                        <ReactBootstrap.Col lg={3}>
                                        </ReactBootstrap.Col>
                                        <ReactBootstrap.Col lg={6}>
                                            <ReactBootstrap.Button bsStyle="primary" onClick={this.login} bsSize="large" block>Login</ReactBootstrap.Button>
                                        </ReactBootstrap.Col>
                                        </div>
                                    </ReactBootstrap.FormGroup>
                                </div>
                            </div>
                        </ReactBootstrap.Form>
                    </div>
                </div>
                </div>
                <MainFooter/>
            </div>

        if(this.state.redirecting !== "") {
            output = this.state.redirecting;
        }
        return (
            output
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Authentication/login.js